import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33c2675a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("钉钉质检")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("一键导出")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("质检")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_11 = { style: {"display":"flex","justify-content":"flex-end","padding-top":"8px"} }
const _hoisted_12 = {
  class: "msi-form",
  style: {"padding-top":"0px"}
}
const _hoisted_13 = /*#__PURE__*/_createTextVNode("批量更新")
const _hoisted_14 = {
  class: "msi-content",
  style: {"margin-top":"0","padding":"0"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("更新")
const _hoisted_16 = { class: "msi-content" }
const _hoisted_17 = { class: "drawer_content" }
const _hoisted_18 = { class: "dialog-footer" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("确认")

import { reactive, ref } from "vue";
import {
  getReceiveRecord,
  getReceiveexport,
  TestingRecordDetailsData,
  TestingRecorddelete,
  dingdingDetailsData,
  dingdingupdataData,
  dingQualified
} from "@/service/main/statistical";
import { downLoadRecordFunction } from "@/service/main/downLoad/index";
import { inMethods, Result, ResultNumber } from "./receivingRecord";
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import dragMenu from "@/components/drag-menu/index.vue";
import Pagination from "@/components/Pagination/index.vue";
import { getSysDicListData } from "@/service/main/system/dic";
import { exportExcel } from "@/utils/exportExcel";
// 顶部占位过多 展开/收起

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const hidden = ref(false);
const openSearch = () => {
  hidden.value = !hidden.value;
};

//单元格样式设置
const rowClass = (
  row: any,
  column: number,
  rowIndex: number,
  columnIndex: number
) => {
  if (row.rowIndex === 0) {
    return "color: #606266;font-weight: bold;";
  }
};
const cellClass = (
  row: any,
  column: number,
  rowIndex: number,
  columnIndex: number
) => {
  if (row.column.label == "采购类型" && row.row.deliveryType == "加急件") {
    return "color: #F56C6C;font-weight: bold;";
  }
};
// 步骤条内容
let tableHeight = ref(0)
// onMounted(() => {
    tableHeight.value = window.innerHeight - 240;
// })
// 列表的每一列
const checkList = ref([
  "项目编号",
  "采购单号",
  "送货单号",
  "供应商",
  "收货时间",
  "序号",
  "品名",
  "品号",
  "规格型号",
  "单位",
  "检验方式",
  "收货数量",
  "是否质检",
  "质检结果",
  "质检结果数量",
  "质检时间",
  "合格数",
  "操作人",
  "物料二维码",
  "操作"
]);
// 当前选中的多选框，代表当前展示的列
const checkedColumns = ref([
  "项目编号",
  "采购单号",
  "送货单号",
  "供应商",
  "收货时间",
  "序号",
  "品名",
  "品号",
  "规格型号",
  "单位",
  "检验方式",
  "收货数量",
  "是否质检",
  "是否合格",
  "质检结果",
  "质检结果数量",
  "质检时间",
  "合格数",
  "操作人",
  "操作"
]);

// 获取是否质检下拉框数据
const IsQualityOrNot: any = ref([]);
const getIsQualityData = () => {
  const obj = {
    Code: "yes_or_no"
  };
  getSysDicListData(obj).then((res) => {
    const { data } = res;
    IsQualityOrNot.value = data;
  });
};
getIsQualityData();

// 获取质检结果下拉框数据
const QualityResultData: any = ref([
  { label: "全部", value: -10 },
  { label: "合格", value: 1 },
  { label: "返修", value: 2 },
  { label: "报废", value: 3 },
  { label: "技术确认", value: 4 },
  { label: "让步接收", value: 5 },
  { label: "退货", value: 6 }
]);

//查询
const formModel = reactive({
  SearchBeginTime: "",
  SearchEndTime: "",
  CreateDate: [],
  PageNo: 1,
  PageSize: 20,
  PurchaseNo: "",
  DeliveryNo: "",
  ProjectCode: "",
  IsQuality: "-10",
  QualityResult: -10,
  createdUserName: "",
  Code: ""
});

//重置
const resetForm = () => {
  formModel.PageNo = 1;
  formModel.PageSize = 20;
  formModel.DeliveryNo = "";
  formModel.ProjectCode = "";
  formModel.SearchBeginTime = "";
  formModel.SearchEndTime = "";
  formModel.CreateDate = [];
  formModel.PurchaseNo = "";
  formModel.IsQuality = "-10";
  formModel.QualityResult = -10;
  formModel.createdUserName = "";
  formModel.Code = "";
  getTabelData();
};

//收货记录查询列表
let tableData = ref([]);
let tableDataexport = ref([]);
//收货记录查询列表的数据条数
const totalItems = ref<number>(0);
//获取菜单列表
const getTabelData = () => {
  if (formModel.CreateDate !== null && formModel.CreateDate.length !== 0) {
    formModel.SearchBeginTime = formModel.CreateDate[0];
    formModel.SearchEndTime = formModel.CreateDate[1];
  }
  getReceiveRecord(formModel).then((res) => {
    const { data } = res;
    const arr: any = [];
    data.rows.forEach((item: any) => {
      arr.push({
        id: item.id,
        projectCode: item.projectCode,
        purchaseNo: item.purchaseNo,
        collectType: item.collectDelivery.collectType,
        deliveryNo: item.collectDelivery.deliveryNo,
        code: item.code,
        name: item.name,
        specificationModel: item.specificationModel,
        unit: item.unit,

        inspectionMethod: item.inspectionMethod,
        brandName: item.brandName,
        collectQuantity: item.collectQuantity,
        isQuality: item.isQuality,

        isQualified: item.isQualified,

        qualityResult: item.qualityResult,
        supplierInfoCode: item.collectDelivery.supplierInfoCode,
        createdTime: item.createdTime,
        materialTagCode: item.materialTagCode,
        createdUserName: item.createdUserName,
        qualityNumber: item.qualityNumber,
        updatedTime: item.updatedTime,
        xuHao: item.xuHao,
        hege: ResultNumber(item)
      });
    });
    tableData.value = arr;
    totalItems.value = data.totalRows;
    formModel.SearchBeginTime = "";
    formModel.SearchEndTime = "";
  });
  getReceiveexport(formModel).then((res) => {
    const { data } = res;
    tableDataexport.value = data;
    tableDataexport.value.forEach((item: any) => {
      (item.collectType = item.collectDelivery.collectType),
        (item.deliveryNo = item.collectDelivery.deliveryNo),
        (item.supplierInfoCode = item.collectDelivery.supplierInfoCode),
        (item.hege = ResultNumber(item));
      item.qualityResult = Result(item.qualityResult);
      item.inspectionMethod = inMethods(item.inspectionMethod);
      item.isQuality = item.isQuality == 1 ? "是" : "否";
    });
    formModel.SearchBeginTime = "";
    formModel.SearchEndTime = "";
  });
};
getTabelData();

//质检按钮
const NailData = reactive({
  PageNo: 1,
  PageSize: 10,
  Code: "",
  DeliveryNo: "",
  ProjectCode: ""
});

// 新增/编辑出库单据列表数据
const warehousOrderDetails = ref<any[]>([]);
//收货更新列表的数据条数
const updatatotalItems = ref<number>(0);
const adddialogVisible = ref(false);
const qualityInspection = () => {
  adddialogVisible.value = true;
  dingdingDetailsData(NailData).then((res: any) => {
    warehousOrderDetails.value = res.data.rows;
    updatatotalItems.value = res.data.totalRows;
  });
};

const updatamaterial = (scope: string) => {
  let para = {
    deliveryNo: scope
  };
  dingdingupdataData(para)
    .then((res: any) => {
      console.log(res);
      adddialogVisible.value = false;
    })
    .catch((err) => {
      adddialogVisible.value = false;
    });
};
const qualityAll = () => {
  const paras: any = [];
  warehousOrderDetails.value.forEach((item: any) => {
    paras.push(item.deliveryNo);
  });
  console.log(paras);
  let para = {
    deliveryNo: paras
  };
  dingQualified(para)
    .then((res: any) => {
      // console.log(res)
      adddialogVisible.value = false;
    })
    .catch((err) => {
      adddialogVisible.value = false;
    });
};
// 收货单详情抽屉默认关闭状态
const dialogVisible = ref(false);
// 获取质检参数定义
const eform = reactive({
  qualityNumber: "",
  qualityResult: "",
  id: 0
});

// 点击质检
const fountnum = ref(1);
const qualityTesting = (scope: any) => {
  console.log(scope);
  dialogVisible.value = true;
  eform.id = scope.id;
  fountnum.value = scope.collectQuantity;
  eform.qualityNumber = scope.collectQuantity;
  if (scope.qualityResult !== 0) {
    eform.qualityResult = scope.qualityResult;
  }
};

// 点击删除
const deleteTesting = (val: number) => {
  let para = {
    id: val
  };
  ElMessageBox.confirm("是否确认删除？", "提示", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning"
  })
    .then(() => {
      TestingRecorddelete(para).then((res) => {
        ElMessage.success("删除成功");
        getTabelData();
      });
    })
    .catch(() => {
      ElMessage.info("已取消删除");
    });
};

const confirmtrue = () => {
  TestingRecordDetailsData(eform)
    .then((res: any) => {
      getTabelData();
      dialogVisible.value = false;
      ElMessage.success("操作成功");
      getTabelData();
      // ElMessage.success(res.message)
    })
    .catch((err) => {
      ElMessage.error(err.message);
    });
};

// 点击质检按钮弹出页面质检结果下拉框
const receivquanty: any = ref([
  { label: "N/A", value: 0 },
  { label: "合格", value: 1 },
  { label: "返修", value: 2 },
  { label: "报废", value: 3 },
  { label: "技术确认", value: 4 },
  { label: "让步接收", value: 5 },
  { label: "退货", value: 6 }
]);

// 质检弹窗关闭
const closeDialog = () => {
  dialogVisible.value = false;
};

// 图片下载
const downLoadImg = (scope: any) => {
  if (scope) {
    scope.split(",").forEach((item: any) => {
      const obj = {
        Id: item
      };
      downLoadRecordFunction(obj).then((res: any) => {
        const link = document.createElement("a"); //创建a标签
        let blob = new Blob([res], { type: "application/octet-stream" }); // response就是接口返回的文件流
        let objectUrl = URL.createObjectURL(blob);
        link.href = objectUrl;
        link.download = scope.fileOriginName; // 自定义文件名
        link.click(); // 下载文件
        URL.revokeObjectURL(objectUrl); // 释放内存
      });
    });
  } else {
    ElMessage.warning("无图片");
  }
};

// 选中的行
const checkRows = ref<{ id: number }[]>([]);
// 选择
const handleSelectionChange = (val: any) => {
  checkRows.value = val;
};
//导出确认按钮
const locallistExport = (num: number) => {
  let entozh = {
    id: "序号",
    purchaseNo: "采购单号",
    collectType: "采购类型",
    deliveryNo: "送货单号",
    supplierInfoCode: "供应商",
    createdTime: "收货时间",
    xuHao: "序号",
    code: "品号",
    name: "品名",
    specificationModel: "规格型号",
    unit: "单位",
    inspectionMethod: "检验方式",
    brandName: "品牌名称",
    collectQuantity: "收货数量",
    isQuality: "是否质检",
    qualityResult: "质检结果",
    qualityNumber: "质检结果数量",
    updatedTime: "质检时间",
    hege: "合格数",
    materialTagCode: "物料二维码"
  };
  if (num == 1) {
    exportExcel(checkRows.value, entozh, "xlsx", "收货列表");
  }
  if (num == 2) {
    if (tableDataexport.value.length !== 0) {
      exportExcel(tableDataexport.value, entozh, "xlsx", "收货列表");
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input_number = _resolveComponent("el-input-number")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: _unref(formModel),
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "项目编号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formModel).ProjectCode,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).ProjectCode) = $event)),
                        clearable: "",
                        placeholder: "请输入项目编号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "送货单号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _unref(formModel).DeliveryNo,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formModel).DeliveryNo) = $event)),
                        clearable: "",
                        placeholder: "请输入送货单号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "收货时间:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _unref(formModel).CreateDate,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formModel).CreateDate) = $event)),
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "YYYY-MM-DD",
                        style: {"width":"100%"},
                        "append-to-body": false
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 8 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createElementVNode("span", {
                        onClick: openSearch,
                        class: "openSearch_Style"
                      }, [
                        _createTextVNode(_toDisplayString(hidden.value ? "收起" : "展开") + " ", 1),
                        _createElementVNode("i", {
                          class: _normalizeClass(hidden.value ? 'el-icon-arrow-up' : 'el-icon-arrow-down')
                        }, null, 2)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (hidden.value)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 0,
                    span: 5
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "是否质检:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(formModel).IsQuality,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formModel).IsQuality) = $event)),
                            placeholder: "请选择是否质检",
                            size: "large",
                            style: {"width":"100%"},
                            "popper-append-to-body": false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(IsQualityOrNot.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (hidden.value)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 1,
                    span: 5
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "质检结果:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _unref(formModel).QualityResult,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formModel).QualityResult) = $event)),
                            placeholder: "请选择质检结果",
                            size: "large",
                            style: {"width":"100%"},
                            "popper-append-to-body": false
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(QualityResultData.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (hidden.value)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 2,
                    span: 5
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "品号:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(formModel).Code,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formModel).Code) = $event)),
                            clearable: "",
                            placeholder: "请输入品号"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (hidden.value)
                ? (_openBlock(), _createBlock(_component_el_col, {
                    key: 3,
                    span: 5
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "操作人:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(formModel).createdUserName,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formModel).createdUserName) = $event)),
                            clearable: "",
                            placeholder: "请输入操作人"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: qualityInspection
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "success",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (locallistExport(1))),
            disabled: checkRows.value.length == 0
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "warning",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (locallistExport(2)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", null, [
          _createVNode(dragMenu, {
            modelValue: checkedColumns.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((checkedColumns).value = $event)),
            checkList: checkList.value,
            "onUpdate:checkList": _cache[10] || (_cache[10] = ($event: any) => ((checkList).value = $event))
          }, null, 8, ["modelValue", "checkList"])
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        "max-height": _unref(tableHeight),
        border: "",
        "header-cell-style": rowClass,
        "cell-style": cellClass,
        class: "tableClass",
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            fixed: "",
            type: "selection",
            align: "center",
            width: "60"
          }),
          _createVNode(_component_el_table_column, {
            fixed: "",
            label: "项目编号",
            prop: "projectCode",
            align: "center",
            width: "140"
          }),
          _createVNode(_component_el_table_column, {
            label: "采购单号",
            prop: "purchaseNo",
            align: "center",
            width: "140"
          }),
          _createVNode(_component_el_table_column, {
            label: "采购类型",
            prop: "collectType",
            align: "center",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            label: "送货单号",
            prop: "deliveryNo",
            align: "center",
            width: "160"
          }),
          _createVNode(_component_el_table_column, {
            label: "供应商",
            prop: "supplierInfoCode",
            align: "center",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            label: "收货时间",
            prop: "createdTime",
            align: "center",
            width: "180"
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            prop: "xuHao",
            align: "center",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            label: "主件品号",
            prop: "mainCode",
            align: "center",
            width: "140"
          }),
          _createVNode(_component_el_table_column, {
            label: "品号",
            prop: "code",
            align: "center",
            width: "140"
          }),
          _createVNode(_component_el_table_column, {
            label: "品名",
            prop: "name",
            align: "center",
            width: "250"
          }),
          _createVNode(_component_el_table_column, {
            label: "规格型号",
            prop: "specificationModel",
            align: "center",
            width: "250"
          }),
          _createVNode(_component_el_table_column, {
            label: "单位",
            prop: "unit",
            align: "center",
            width: "80"
          }),
          _createVNode(_component_el_table_column, {
            label: "检验方式",
            align: "center",
            prop: "inspectionMethod",
            width: "120"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(_unref(inMethods)(scope.row.inspectionMethod)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "品牌名称",
            prop: "brandName",
            align: "center",
            width: "160"
          }),
          _createVNode(_component_el_table_column, {
            label: "收货数量",
            prop: "collectQuantity",
            align: "center",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            label: "是否质检",
            prop: "isQuality",
            align: "center",
            width: "120"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(scope.row.isQuality == 1 ? "是" : "否"), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "质检结果",
            prop: "qualityResult",
            align: "center",
            width: "120"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", null, _toDisplayString(_unref(Result)(scope.row.qualityResult)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "质检结果数量",
            prop: "qualityNumber",
            width: "110",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "质检时间",
            prop: "updatedTime",
            width: "180",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            label: "合格数",
            align: "center",
            prop: "hege",
            width: "120"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作人",
            align: "center",
            prop: "createdUserName",
            width: "120"
          }),
          (checkedColumns.value.indexOf('物料二维码') >= 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: "物料二维码",
                prop: "materialTagCode",
                align: "center",
                width: "300"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作",
            width: "200",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                onClick: ($event: any) => (qualityTesting(scope.row)),
                disabled: scope.row.inspectionMethod == 0
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"]),
              _createVNode(_component_el_button, {
                type: "danger",
                size: "small",
                onClick: ($event: any) => (deleteTesting(scope.row.id)),
                disabled: scope.row.isQuality !== 0
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "max-height"]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(Pagination, {
          total: totalItems.value,
          page: _unref(formModel).PageNo,
          "onUpdate:page": _cache[11] || (_cache[11] = ($event: any) => ((_unref(formModel).PageNo) = $event)),
          limit: _unref(formModel).PageSize,
          "onUpdate:limit": _cache[12] || (_cache[12] = ($event: any) => ((_unref(formModel).PageSize) = $event)),
          onPagination: getTabelData
        }, null, 8, ["total", "page", "limit"])
      ]),
      _createVNode(_component_el_dialog, {
        modelValue: adddialogVisible.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((adddialogVisible).value = $event)),
        title: "钉钉质检",
        width: "86%",
        onClose: closeDialog
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: qualityAll,
              style: {"margin-bottom":"10px"}
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_table, {
              data: warehousOrderDetails.value,
              ref: "multipleTableRef",
              border: "",
              style: {"width":"100%"},
              "max-height": "400px",
              "header-cell-style": rowClass
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "序号",
                  align: "center",
                  width: "60",
                  type: "index"
                }),
                _createVNode(_component_el_table_column, {
                  label: "项目编号",
                  align: "center",
                  prop: "projectCode"
                }),
                _createVNode(_component_el_table_column, {
                  label: "采购单号",
                  prop: "purchaseNo",
                  align: "center",
                  width: ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "采购类型",
                  prop: "deliveryType",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "送货单号",
                  prop: "deliveryNo",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "供应商",
                  prop: "suppCode",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "small",
                      onClick: ($event: any) => (updatamaterial(scope.row.deliveryNo))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(Pagination, {
              total: updatatotalItems.value,
              page: _unref(NailData).PageNo,
              "onUpdate:page": _cache[13] || (_cache[13] = ($event: any) => ((_unref(NailData).PageNo) = $event)),
              limit: _unref(NailData).PageSize,
              "onUpdate:limit": _cache[14] || (_cache[14] = ($event: any) => ((_unref(NailData).PageSize) = $event)),
              onPagination: qualityInspection,
              style: {"margin-top":"20px","text-align":"center"}
            }, null, 8, ["total", "page", "limit"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((dialogVisible).value = $event)),
        title: "质检结果",
        width: "30%",
        height: "500px",
        onClose: closeDialog
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_18, [
            _createVNode(_component_el_button, {
              onClick: _cache[18] || (_cache[18] = ($event: any) => (dialogVisible.value = false))
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: confirmtrue
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_el_form, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "质检数量:",
                    prop: "isQuality"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _unref(eform).qualityNumber,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(eform).qualityNumber) = $event)),
                        min: 1,
                        max: fountnum.value,
                        style: {"width":"67%"}
                      }, null, 8, ["modelValue", "max"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "质检结果:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _unref(eform).qualityResult,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(eform).qualityResult) = $event)),
                        placeholder: "请选择质检结果",
                        size: "large",
                        style: {"width":"67%","height":"300px"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(receivquanty.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})